module.exports = __webpack_public_path__ + "e5f6dc5f224132d46c27eb74edc13a2e.svg";